import { memo } from 'react';
import { LAYOUT_CONFIGS, type GalleryLayoutVariant } from '../../types/gallery';
import './LayoutSelector.css';

// ==========================================
// TYPES
// ==========================================

interface LayoutSelectorProps {
  currentLayout: GalleryLayoutVariant;
  onLayoutChange: (layout: GalleryLayoutVariant) => void;
  showLabels?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

// ==========================================
// COMPONENT
// ==========================================

function LayoutSelectorComponent({
  currentLayout,
  onLayoutChange,
  showLabels = false,
  size = 'md',
  className = '',
}: LayoutSelectorProps) {
  return (
    <div
      className={`layout-selector layout-selector--${size} ${className}`}
      role="radiogroup"
      aria-label="Gallery layout"
    >
      {LAYOUT_CONFIGS.map(({ variant, label, description, icon }) => (
        <button
          key={variant}
          className={`layout-selector__btn ${currentLayout === variant ? 'active' : ''}`}
          onClick={() => onLayoutChange(variant)}
          role="radio"
          aria-checked={currentLayout === variant}
          title={description}
        >
          <span className="layout-selector__icon">{icon}</span>
          {showLabels && <span className="layout-selector__label">{label}</span>}
        </button>
      ))}
    </div>
  );
}

export const LayoutSelector = memo(LayoutSelectorComponent);
